import React from 'react';

export default function ImageHeader(props) {
    const { imagePath, mobileImagePath, imageALT, imageTitle, width, height } = props;
    return (
        <div className="imageHeaderWrapper">
            <picture>
                {mobileImagePath && (
                    <source media="(max-width: 767px)" srcSet={mobileImagePath} />
                )}
                <img
                    className="img-fluid headerImage"
                    src={imagePath}
                    alt={imageALT}
                    title={imageTitle}
                    width={width}
                    height={height}
                />
            </picture>
        </div>
    );
}
